module.exports = __webpack_public_path__ + "img/could_right.8a280a64.png";